import axios from "axios";

const businessTermsBaseURL = `/api/v1/business_terms`;

const fetch = (
  search = "",
  currentPage = 1,
  pageSize = 10,
  filterBy = "",
  filterValue = ""
) =>
  axios.get(
    `${businessTermsBaseURL}?search=${search}&page=${currentPage}&per_page=${pageSize}&filter_by=${filterBy}&filter_value=${filterValue}`
  );

const show = id => axios.get(`${businessTermsBaseURL}/${id}`);

const create = payload => axios.post(businessTermsBaseURL, payload);

const update = (id, payload) =>
  axios.put(`${businessTermsBaseURL}/${id}`, payload);

const destroy = ids => {
  const params = new URLSearchParams(ids.map(id => ["ids[]", id]));
  return axios.delete(`/api/v1/business_terms/1?${params.toString()}`);
};

const fetchSummary = payload =>
  axios.get(`${businessTermsBaseURL}/summary_graph?limit_from=${payload}`);

const businessTermsApi = {
  fetch,
  create,
  show,
  update,
  destroy,
  fetchSummary,
};

export default businessTermsApi;
